import { DateTime } from 'luxon';
import { StringEnum, type StringEnumType } from '../enums.ts';
import { capitalize } from '../strings.ts';
export { DateTime } from 'luxon';

export const DaysOfWeek = new StringEnum('mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun');
export type DayOfWeek = StringEnumType<typeof DaysOfWeek>;

export const DayNames = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;
export type DayName = (typeof DayNames)[number];

export const ShortDayNames = Object.freeze(DaysOfWeek.values.map(capitalize));
export type ShortDayName = (typeof ShortDayNames)[number];

export function dayOfWeek(date: DateTime): DayOfWeek {
  return DaysOfWeek.values[date.weekday - 1];
}
